module.exports = __webpack_public_path__ + "static/cely_rose_grossesse_3-d86423ea25e0441d904f461aac1de2b0.jpg";